// ── Shared colors ───────────────────────────────────────────────────

export const BG_CANVAS = '#e5e5e5';
export const COLOR_TEXT = '#333';
export const COLOR_MUTED = '#666';
export const COLOR_ACCENT = '#3cc6f4';
export const COLOR_RED = '#C00000';
export const COLOR_RED_DARK = '#FF5923';

// ── Shared font families ─────────────────────────────────────────────

export const FONT_INTER = 'Inter, sans-serif';

// ── Shared page-body padding ─────────────────────────────────────────
// Uniform inner content margin across all page types for a safe print margin.

export const PAGE_BODY_PADDING = '0px';

// ── Navigation bar ──────────────────────────────────────────────────

export const NAV_BAR_STYLE: React.CSSProperties = {
	position: 'absolute',
	top: '8px',
	right: '20px',
	zIndex: 10,
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	backgroundColor: 'rgba(255,255,255,0.9)',
	padding: '4px 12px',
	borderRadius: '4px',
	boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
	fontSize: '11px',
	color: COLOR_TEXT
};

export const NAV_BUTTON_STYLE: React.CSSProperties = {
	border: 'none',
	background: 'none',
	cursor: 'pointer',
	fontSize: '14px',
	color: COLOR_TEXT,
	padding: '0 4px'
};

// Add-sheet affordance: a ghost page that sits in the stack below the last sheet, matching
// BlueprintPageWrapper's box so it reads as the next (empty) page rather than as chrome.
export const ADD_PAGE_GHOST_WIDTH_PX = 1100;
export const ADD_PAGE_GHOST_HEIGHT_PX = 850;
export const ADD_PAGE_GHOST_MARGIN_PX = 20;

export const ADD_PAGE_GHOST_STYLE: React.CSSProperties = {
	width: `${ADD_PAGE_GHOST_WIDTH_PX}px`,
	height: `${ADD_PAGE_GHOST_HEIGHT_PX}px`,
	flexShrink: 0,
	margin: `0 auto ${ADD_PAGE_GHOST_MARGIN_PX}px auto`,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: 0,
	background: 'rgba(255,255,255,0.45)',
	border: '2px dashed #bdbdbd',
	borderRadius: '2px',
	cursor: 'pointer',
	transition: 'background 120ms ease, border-color 120ms ease, color 120ms ease',
	color: '#bdbdbd'
};

export const ADD_PAGE_GHOST_HOVER_STYLE: React.CSSProperties = {
	background: 'rgba(255,255,255,0.85)',
	borderColor: COLOR_ACCENT,
	color: COLOR_ACCENT
};

export const ADD_PAGE_GHOST_PLUS_STYLE: React.CSSProperties = {
	// The '+' glyph fills well under half its em box, so this reads as roughly a 100px mark on the sheet.
	fontSize: '240px',
	lineHeight: 1,
	fontWeight: 200,
	color: 'inherit',
	userSelect: 'none'
};

export const EXPORT_ERROR_STYLE: React.CSSProperties = {
	maxWidth: '260px',
	fontSize: '10px',
	color: COLOR_RED,
	cursor: 'pointer'
};

export const exportButtonStyle = (isExporting: boolean): React.CSSProperties => ({
	border: '1px solid #666',
	background: '#fff',
	cursor: isExporting ? 'not-allowed' : 'pointer',
	fontSize: '10px',
	color: isExporting ? '#999' : COLOR_TEXT,
	padding: '2px 8px',
	borderRadius: '3px',
	opacity: isExporting ? 0.6 : 1
});

// ── Scroll container ────────────────────────────────────────────────

export const SCROLL_CONTAINER_STYLE: React.CSSProperties = {
	width: '100%',
	height: '100%',
	overflowY: 'auto',
	overflowX: 'auto',
	scrollBehavior: 'auto',
	backgroundColor: BG_CANVAS,
	padding: '20px'
};
